import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { SELECT_REGION } from 'apps/promo/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';
import clsx from 'clsx';

import styles from './Footer.module.css';
import { LightFlagIcon } from '../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { PromoText } from '../common/promo-text/PromoText';

const FooterCountry = (props) => {
    const regionClass = clsx(styles.footerRegion, {
        [styles.footerRegionBlack]: props.promoDarkPage,
    });

    const { countryCode, countryName, country } = props;
    const location = useLocation();

    const onClick = () => {
        let prefix = getLangCountryPrefix(props.lang, country);
        let pathname = location.pathname;
        let slug;

        if (pathname.indexOf(prefix) != '-1') {
            slug = pathname.slice(7);
        } else {
            slug = pathname.slice(1);
        }

        sessionStorage?.setItem('prevSlug', slug);
    };

    return (
        <div className={regionClass}>
            <PromoText
                tag="link"
                onClick={onClick}
                href={`${getLangCountryPrefix(props.lang, country)}${SELECT_REGION}`}
                data-testid="footer-country-link-region"
            >
                <LightFlagIcon name={countryCode} size="24px" />
                <span className={styles.countryName}>{countryName}</span>
            </PromoText>
        </div>
    );
};

FooterCountry.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
    };
};

export default connect(mapStateToProps, null)(FooterCountry);
